<template>
  <li class="col-span-1 flex flex-col">
    <div
      class="w-full flex flex-col gap-2 px-4 justify-center items-center h-32 cursor-pointer rounded-md shadow-lg"
      :class="{
        'bg-untitled-gray-100 hover:bg-untitled-gray-200 text-untitled-gray-600': !kintzApp,
        'bg-kintz-primary-1 text-kintz-primary-2 hover:bg-kintz-primary-3': kintzApp,
      }"
      @click="handleClickCard"
    >
      <p class="text-4xl font-semibold ">{{ value }}</p>
      <p class="text-xs  text-center font-medium">
        {{ text }}
      </p>
    </div>
  </li>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
const props = defineProps({
  text: {
    type: String,
    default: "",
  },
  value: {
    type: Number,
    default: null,
  },
  prop: {
    type: String,
    default: "",
  },
  kintzApp: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(["onClickCard"]);

const text = computed(() => props.text);
const value = computed(() => props.value);
const prop = computed(() => props.prop);

const handleClickCard = () => {
  emit("onClickCard", prop.value);
};
</script>

<style lang="scss" scoped></style>
